











































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { MedicalSpecification } from "@/components/medicalTransmissionEdit/types";
import EditDayChangePicker from "@/components/common/EditDayChangePicker.vue";

@Component({
  components: { EditDayChangePicker }
})
export default class BasicInfo10 extends Vue {
  @Prop() tab!: MedicalSpecification;
}
